@if(mobile){
    <app-download></app-download>
}@else {
    <router-outlet></router-outlet>
}